<template>
    <RadioButtonGroup
        :name="`${step.name}[${data.element_details.name}]`"
        class="big-radio--group"
        :unstyled="true"
        v-model="field.value"
    >   
        
        <div :class="'big-radio ' + isSelected(field.value, option.value)" v-for="(option, index) in data.valueOptions">

            <RadioButton
                :inputId="`${step.name}[${data.element_details.name}]` + '-' + option.value"
                :value="option.value"
                @change="onRadioChange"
            />

            
            <label :for="`${step.name}[${data.element_details.name}]` + '-' + option.value">
                <div class="big-radio--image" v-if="option.valueImage?.['icon-base64']">
                    <img :src="option.valueImage['icon-base64']" :alt="option.valueImage['label']">
                </div>
                <div class="big-radio--label">
                    {{ option.label }}
                </div>
            </label>

        </div>

    </RadioButtonGroup>
</template> 

<script setup>
const props = defineProps({
    data:Object,
    field:Object,
    step:Object
})

const emit = defineEmits(['update:slideForward']);

function isSelected(cValue, fValue){
    if(cValue == fValue) {
        return 'is-active';  
    } 
    return '';
}

function onRadioChange() {
    if (!!props.data.jump) {
        emit('update:slideForward');
    }
}
</script>